import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SharedModule } from '@app/shared'
import { FormsModule } from '@angular/forms'
import { UserProfileComponent } from './dialogs/user-profile/user-profile.component'
import { UserSettingsComponent } from './dialogs/user-settings/user-settings.component'

@NgModule({
  declarations: [UserProfileComponent, UserSettingsComponent],
  imports: [CommonModule, SharedModule, FormsModule],
  exports: [UserProfileComponent, UserSettingsComponent],
})
export class UserModule {}
